export const ADD_SUCCESS = 'Новое мобильное приложение добавлено';
export const ADD_ERROR = 'Не удалось добавить мобильное приложение';
